import Vue from 'vue';
import VueRouter from 'vue-router';
import LoginPage from '../views/LoginPage.vue';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LoginPage,
  },
  {
    path: '/criteria',
    name: 'Criteria',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagingCriteria.vue'),
  },
  {
    path: '/rw-form/:id',
    exact: true,
    name: 'Performing Review Form',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PerformingReviewForm.vue'),
  },
  {
    path: '/rw-session',
    exact: true,
    name: 'Review Session',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagingReviewSession.vue'),
  },
  {
    path: '/rw-form',
    exact: true,
    name: 'Review Form',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagingReviewForm.vue'),
  },
  {
    path: '/users',
    name: 'User',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagingUser.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginPage.vue'),
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/rv-result',
    name: 'Result',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagingReviewResult.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const protectedRoutes = [
  'Criteria',
  'Performing Review Form',
  'Review Form',
  'Review Session',
  'User',
  'Login',
  'Result',
];

const adminRoutes = ['Criteria', 'User', 'Review Session'];

router.beforeEach((to, from, next) => {
  const { idToken, type } = store.state.app?.user;

  if (protectedRoutes.includes(to.name) && !idToken) {
    next('/');
  } else if (adminRoutes.includes(to.name) && type !== 'ADMIN') {
    next('/');
  } else {
    next();
  }
});

export default router;
